export const useStyles = (theme) => ({
    bannerImagePreview: {
        width: '100%'
    }
})
